import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useDataContext } from './useDataContext';
import { useLSContext } from './useLSContext';

interface HoleSettingsContextType {
    holeSettings: any;
    setHoleSettings: (holeSettings: any) => void;
}

const HoleSettingsContext = createContext<HoleSettingsContextType | null>(null);

export const HoleSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [holeSettings, setHoleSettings] = useState<any>({});
    const { currentHole } = useLSContext();
    const { eventData, courseData, scoreData } = useDataContext();

    // Update hole settings when hole, event, or course changes
    /* useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            console.log('HS - Current Hole Changed to:', currentHole);
            console.log('HS - Event Data:', eventData);
            console.log('HS - Course Data:', courseData);
        }
        
        if (eventData && Object.keys(eventData).length > 0 && 
            courseData && Object.keys(courseData).length > 0 &&
            currentHole > 0) {

            const playerTeeSet = eventData.playerTeeSet || 
                (courseData.teeSets && courseData.teeSets.length > 0 ? courseData.teeSets[0].teeName : null);
            console.log('HS - Player Tee Set:', playerTeeSet);
            
            if (playerTeeSet && courseData.teeSets) {
                const teeSet = courseData.teeSets.find((tee: any) => tee.teeName === playerTeeSet);
                console.log('HS - Tee Set:', teeSet);
                
                if (teeSet && teeSet.holes && teeSet.holes.length >= currentHole) {
                    const teesData = teeSet.holes[currentHole-1];
                    console.log('HS - Tee Set Data:', teesData);
                    setHoleSettings(
                            hole: currentHole,
                            par: teesData.par,
                            dist: teesData.dist,
                            hdcp: teesData.hdcp
                    });
                }
            }
        }
    }, [currentHole, eventData, courseData]); */

    const value = useMemo(() => ({
        holeSettings,
        setHoleSettings
    }), [holeSettings]);

    return (
        <HoleSettingsContext.Provider value={value}>
            {children}
        </HoleSettingsContext.Provider>
    );
};

export const useHoleSettings = () => {
    const context = useContext(HoleSettingsContext);
    
    if (!context) {
        throw new Error('useHoleSettings must be used within a HoleSettingsProvider');
    }
    
    return context;
};